<template>
    <div>
        <BigButton
            data-test-id="pdp-add-to-cart-button"
            task="addToCart"
            :class="cn('bg-order-buttons font-extrabold text-white', disabled && 'opacity-50')"
            :label="addToCartButtonLabel"
            :disabled="disabled"
            @click="handleClick"
            :loading="isAddingToCart"
        />

        <ProductOptionsModal v-model:open="modalOpen" />

        <AddToCartErrorModal
            v-model:open="cartError"
            :description="$t('pages.product_detail_page.product_info.product_button.add_to_cart.error')"
            @retry="handleClick"
        />

        <ActionStatus kind="addToCart" :state="isAddingToCart ? 'loading' : null" />
    </div>
</template>

<script setup lang="ts">
import BigButton from '@/components/buttons/BigButton.vue';
import AddToCartErrorModal from '@/components/cart/partials/AddToCartErrorModal.vue';
import { useAddToCart } from '@/composables/cart/useAddToCart';
import { cn } from '@/lib/tailwind';
import ActionStatus from '@/components/status/ActionStatus.vue';
import ProductOptionsModal from '@/pages/product-page/partials/product-info/partials/modals/ProductOptionsModal.vue';
import { useProductOptionsStore } from '@/stores/product-options/ProductOptionsStore';
import { useProductStore } from '@/stores/products/ProductStore';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

type ButtonProps = {
    disabled?: boolean;
};

withDefaults(defineProps<ButtonProps>(), {
    disabled: false,
});

const modalOpen = ref(false);

const productStore = useProductStore();
const productOptionsStore = useProductOptionsStore();
const { addToCart, isLoading: isAddingToCart, cartError } = useAddToCart();
const { t } = useI18n();

// Configured per magento group / configurable product in Joost; falls back to
// the per-locale default when nothing is set.
const addToCartButtonLabel = computed<string>(
    () => productStore.configurableProduct.add_to_cart_button_label || t('components.buttons.default.add_to_cart.label'),
);

function handleClick(): void {
    if (!productOptionsStore.productOptions || productOptionsStore.productOptions.length === 0) {
        void addToCart(productStore.configurableProduct.group_identifier, productStore.selectedProduct.product.sku, 1);

        return;
    }

    modalOpen.value = true;
}
</script>
